import 'angular';
import { searchPageHandlerComponent } from './office-and-advisor-search-page-handler.component';
import OfficeAndAdvisorSearch from '../../application/office-and-advisor-search/office-and-advisor-search.module';
import 'ngmap';

const MODULE_NAME = 'searchPageHandlerComponent';

export default angular.module(MODULE_NAME, ['ngMap', OfficeAndAdvisorSearch]).component('searchPageHandlerComponent', searchPageHandlerComponent).name;


